import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import { Product, ProductProperty } from '@/models/product';
import { asyncForEach, validateFileName } from '@/utils';
import lodash, { forEach, isEmpty } from 'lodash';
var slugify = require('slugify');
import { v4 as uuidv4 } from 'uuid';

export interface ProductState {

    activeProduct: Partial<Product>;
    activeProductLoading: boolean;

    cacheProducts: Array<Product>;
    cacheProductsLoading: boolean;
    allProducts: Array<Product>;
    allProductsLoading: boolean;

    productsPerPage: number;
    productsPage: number;
    productsTotal: number;
}

const defaultProduct = {
    name: '',
    sku: null,
    stock_total: 0,
    stocks: [],
    gallery: [],
    complete_gallery: [],
    keywords: [],
    manufacturersku: '',
    price: 0,
    in_ecommerce: 0,
    properties: [],
    data_sheet: null,
    ean_upc: 0,
    isNew: true,
    is_active: true,
    combo_products: [],
    is_combo: false,
};

const state: ProductState = {
    // activeProduct
    activeProduct: defaultProduct,
    activeProductLoading: false,
    // allProducts
    cacheProducts: [],
    cacheProductsLoading: false,
    // allProducts
    allProducts: [],
    allProductsLoading: false,
    productsPerPage: 1,
    productsPage: 1,
    productsTotal: 1,
};

const formatProduct = (product: Product): Product => {
    // console.log('formatting product...', product);
    let gallery = [];

    if (product.gallery) {
        gallery = product.gallery.map(img => {
            return {
                ...img,
                url: `https://directus.prodelec.app/assets/${img.id}`,
                origin: 'directus',
            };
        });
    }

    let properties = [];

    if (product.properties) {
        properties = product.properties.map(p => {
            let productProperty = lodash.find(product.properties, { name: p.name });
            return {
                ...p,
                value: productProperty ? productProperty.value : null,
            };
        });
    }

    return {
        ...product,
        properties,
        gallery,
    };
};

const mutations = {
    TOGGLE_ALL_PRODUCTS_LOADING(state: ProductState, data: boolean) {
        state.allProductsLoading = data;
    },
    SET_ALL_PRODUCTS(state: ProductState, data: PaginatedCollection) {
        // state.allProducts = data.items.map(product => formatProduct(product));        
        state.allProducts = data.items;
        state.productsPerPage = data.perPage;
        state.productsPage = data.currentPage;
        state.productsTotal = data.totalItems;
    },
    SET_CACHE_PRODUCTS(state: ProductState, data: any) {
        // let cacheProducts = [...state.cacheProducts, ...data].map((p: any) => {
        let cacheProducts = [...data].map((p: any) => {
            return {
                ...p,
                label: `${p.id} ${p.name}`,
            };
        });
        state.cacheProducts = lodash.uniqBy(cacheProducts, 'id');
    },
    TOGGLE_CACHE_PRODUCTS_LOADING(state: ProductState, data: boolean) {
        state.cacheProductsLoading = data;
    },
    SET_ACTIVE_PRODUCT(state: ProductState, product: Product) {
        state.activeProduct = formatProduct(product);
        console.log('SET_ACTIVE_PRODUCT', state.activeProduct);
    },
    TOGGLE_ACTIVE_PRODUCT_LOADING(state: ProductState, data: boolean) {
        state.activeProductLoading = data;
    },
};

const actions = {
    async getOne({ _, commit }: any, id: string | null = null) {
        commit('TOGGLE_ACTIVE_PRODUCT_LOADING', true);
        if (id != null) {
            await directusApi('GET', `items/products/${id}?fields=*,data_sheet.*, category.*, sector.*, application.*, brand.*`).then(async res => {
                commit('SET_ACTIVE_PRODUCT', res.data.data);
            })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_PRODUCT', defaultProduct);
            commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
        }
    },
    async syncSku({ _, commit, dispatch }: any, id: string | null = null) {
        commit('TOGGLE_ACTIVE_PRODUCT_LOADING', true);
        await directusApi('GET', `custom/legacy-intelisis/syncSku/${id}`)
            .then(async res => {
                console.log('Producto sincronizado con intelisis :D');
                alert(`Producto sincronizado correctamente!`);
            })
            .catch(err => {
                console.log({ err });
                alert(`Lo sentimos, ha ocurrido un error al sincronizar el producto.`);
            });
        commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
    },

    async postOne({ _, commit, dispatch }: any, { product, view }: any) {

        console.log('insertando producto...');
        // TERSL1AB4BD
        // 3606480077975

        if (!product.is_combo) {
            if (!product.id) {
                alert('SKU es necesario');
                return false;
            }
            if (!product.manufacturer_sku) {
                alert('Clave de Fabricante es necesario');
                return false;
            }
        }

        // if (product.id.includes('/')) {
        //     alert('La clave contiene caracteres no soportados por el sistema');
        // }

        commit('TOGGLE_ACTIVE_PRODUCT_LOADING', true);

        // if new product post ELSE update existing
        let productMethod: any = 'PATCH';
        let productEndpoint: string = `items/products/${product.id_new}`;
        if (product.hasOwnProperty('isNew')) {
            if (product.isNew) {
                productEndpoint = 'items/products';
                productMethod = 'POST';
            }
        }
        // if (product.is_active) {
        // productMethod = 'PATCH';
        // productEndpoint = `items/products/${product.id}`;
        // }

        // validation for category node ********************************
        if (product.category) {
            if (product.category.hasOwnProperty('id')) {
                product.category = product.category.id;
            } else {
                product.category = +product.category;
            }
        }
        // ********************************
        // validation for sector node ********************************
        if (product.sector) {
            if (product.sector.hasOwnProperty('id')) {
                product.sector = product.sector.id;
            } else {
                product.sector = +product.sector;
            }
        }
        // ********************************
        // validation for application node ********************************
        if (product.application) {
            if (product.application.hasOwnProperty('id')) {
                product.application = product.application.id;
            } else {
                product.application = +product.application;
            }
        }
        // ********************************
        // validation for brand node ********************************
        if (product.brand) {
            if (product.brand.hasOwnProperty('id')) {
                product.brand = product.brand.id;
            } else {
                product.brand = +product.brand;
            }
        }
        //**************************************
        // Validar SKU Único
        console.log(productMethod);

        // ******* START validando EAN UPC ********
        let ean_validation = null;
        try {
            if (product.ean_upc && product.ean_upc != 0) {
                await directusApi('GET', `items/products?&filter[ean_upc][_eq]=${product.ean_upc}`)
                    .then(async (res: any) => {
                        ean_validation = res.data.data;
                    })
                    .catch(err => {
                        console.log(err);
                        ean_validation = null;
                    });
            }
        } catch (error) {
            console.log({ error });
            ean_validation = null;
        }
        let filter_ean_validation = [];
        ean_validation ? filter_ean_validation = ean_validation.filter(item => item.id !== product.id) : filter_ean_validation = [];
        if (filter_ean_validation.length > 0) {
            alert(`Error al guardar, el código de barras ya existe en el producto ${ean_validation[0].id}`);
            commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
            return false;
        }
        // ******* END validando EAN UPC ********

        if (productMethod == 'POST') {
            if (!product.is_combo) {
                if (product.id !== product.id.toUpperCase() || product.manufacturer_sku !== product.manufacturer_sku.toUpperCase()) {//Validar que el SKU este en mayúsculas
                    product.id = product.id.toUpperCase()
                    product.manufacturer_sku = product.manufacturer_sku.toUpperCase()
                    console.log(product.manufacturer_sku);
                    console.log(product.id);
                }
            }


            let value = null;
            try {
                // &filter[order_id][_eq]=${search}
                await directusApi('GET', `items/products?&filter[id][_eq]=${product.id}`)
                    // await directusApi('GET', `items/products?search=${product.id}&limit=1&meta=filter_count`)
                    .then(async (res: any) => {
                        value = res.data.data;
                        console.log(value);
                    })
                    .catch(err => {
                        console.log(err);
                        value = 20;
                    });
            } catch (error) {
                console.log({ error });
                value = 20;
            }
            console.log(value);
            if (value != 0) {
                alert(`Error al guardar, El SKU del producto ya existe.`);
                commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
                return false;
            }
        }

        // ********************************

        let productData: any = {};

        if (product.is_combo) {
            console.log('entra a crear nuevo combo');

            productData = {
                id: product.id,
                slug: slugify(`${product.id} ${product.name.toLowerCase()}`, { replacement: '-', remove: /[*+~.¬=|°,?/%&$#()'"!:@]/g }),
                ean_upc: product.ean_upc > 0 ? product.ean_upc : 0,
                tall: product.tall,
                wide: product.wide,
                weight: product.weight,
                long: product.long,
                name: product.name,
                category: product.category,
                sector: product.sector,
                application: product.application,
                brand: product.brand,
                properties: product.properties.map((p: ProductProperty) => {
                    return {
                        name: p.name,
                        value: p.value,
                    };
                }),
                combo_products: product.combo_products,
                clave_sat: product.clave_sat,
                is_active: product.is_active,
                is_combo: product.is_combo,
                description: product.description,
                price: product.price,
                stock: product.stock_total,
            };
        } else {
            productData = {
                id: product.id,
                manufacturer_sku: product.manufacturer_sku,
                category: product.category,
                slug: slugify(`${product.id} ${product.name.toLowerCase()}`, { replacement: '-', remove: /[*+~.¬=|°,?/%&$#()'"!:@]/g }),
                sector: product.sector,
                application: product.application,
                brand: product.brand,
                properties: product.properties.map((p: ProductProperty) => {
                    return {
                        name: p.name,
                        value: p.value,
                    };
                }),
                tall: product.tall,
                wide: product.wide,
                weight: product.weight,
                long: product.long,
                name: product.name,
                is_active: product.is_active,
                description: product.description,
                // description2: product.description,
                data_sheet: product.data_sheet,
                ean_upc: product.ean_upc > 0 ? product.ean_upc : 0,
            };

            productData.data_sheet == '' ? (productData.data_sheet = null) : (productData.data_sheet = productData.data_sheet);
        }

        try {
            if (productData.data_sheet.origin == 'upload') {
                let fileNameValidation = await validateFileName(productData.data_sheet.name);
                if (fileNameValidation == 0) {
                    console.log('uploading', productData.data_sheet);
                    await directusApi('POST', `files`, productData.data_sheet.file)
                        .then(async (resFile: any) => {
                            productData.data_sheet = { id: resFile.data.data.id };
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else {
                    alert(`Error al guardar, el archivo ${productData.data_sheet.name} ya existe.`);
                    commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
                    return false;
                }
            } else if (productData.data_sheet.origin == 'directus-update') {
                console.log('file only setted');
                productData.data_sheet = { id: productData.data_sheet.id };
            }
        } catch (error) {
            console.log('error => no contiene un archivo');
        }

        let gallery = product.gallery;
        let complete_gallery = product.complete_gallery;
        let validationImgs = true;
        // update product gallery
        await asyncForEach(gallery, async (galleryItem, galleryIndex) => {
            // uploads images
            if (galleryItem.origin == 'upload') {
                if (await validateFileName(galleryItem.name) == 0) {
                    await directusApi('POST', `files`, galleryItem.file)
                        .then(async (resFile: any) => {
                            if (galleryItem.hasOwnProperty('alt')) {
                                await directusApi('PATCH', `files/${resFile.data.data.id}`, { alt: galleryItem.alt })
                                    .then(async (resFile: any) => {
                                        console.log('Alt added');
                                    })
                                    .catch(err => {
                                        console.log(err);
                                    });
                            }
                            validationImgs = true;
                            gallery[galleryIndex] = { id: resFile.data.data.id, sort: null, name: resFile.data.data.title, alt: galleryItem.hasOwnProperty('alt') ? galleryItem.alt : '' };
                            await asyncForEach(complete_gallery, async (complete_gallery_item, complete_gallery_index) => {
                                console.log('posting rezising file :D');
                                if (complete_gallery_item.origin != 'directus') {
                                    await directusApi('POST', `files`, complete_gallery_item.file)
                                        .then(async (resFile: any) => {
                                            if (galleryItem.hasOwnProperty('alt')) {
                                                await directusApi('PATCH', `files/${resFile.data.data.id}`, { alt: galleryItem.alt })
                                                    .then(async (resFile: any) => {
                                                        console.log('Alt added to complete gallery');
                                                    })
                                                    .catch(err => {
                                                        console.log(err);
                                                    });
                                            }
                                            complete_gallery[complete_gallery_index] = {
                                                id: resFile.data.data.id,
                                                sort: null,
                                                name: resFile.data.data.title,
                                                origin: 'directus',
                                                alt: galleryItem.hasOwnProperty('alt') ? galleryItem.alt : '',
                                            };
                                        })
                                        .catch(err => {
                                            console.log(err);
                                        });
                                }
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else {
                    validationImgs = false;
                    alert(`Error al guardar, la imagen ya existe.`);
                    commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
                    return false;
                }
            }

            //Setting images from existing files
            if (galleryItem.origin == 'directus-update') {
                gallery[galleryIndex] = {
                    id: galleryItem.id,
                    sort: null,
                    url: `https://directus.prodelec.app/assets/${galleryItem.id}`,
                    origin: 'directus-update',
                };
            }
            if (galleryItem && galleryItem.hasOwnProperty('alt') && galleryItem.origin != 'upload') {
                await directusApi('PATCH', `files/${galleryItem.id}`, { alt: galleryItem.alt })
                    .then(async (resFile: any) => {
                        if (complete_gallery) {
                            await asyncForEach(complete_gallery, async (complete_gallery_item, complete_gallery_index) => {
                                await directusApi('PATCH', `files/${complete_gallery_item.id}`, { alt: galleryItem.alt })
                                    .then(async (resFile: any) => {
                                        complete_gallery[complete_gallery_index] = {
                                            ...complete_gallery[complete_gallery_index],
                                            alt: galleryItem.alt,
                                        };
                                    })
                                    .catch(err => {
                                        console.log(err);
                                    });
                            });
                            console.log('Alt updated in all gallery');

                        }
                        console.log('Alt updated succesfully');
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        });
        if (!validationImgs) {
            return false;
        }
        // console.log({ gallery });
        // console.log({ complete_gallery });
        // commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
        // create or update product without gallery
        // console.log({ productMethod });
        // console.log({ productEndpoint });
        await directusApi(productMethod, productEndpoint, productData)
            .then(async db_product => {
                console.log('PRODUCT CREATED/UPDATED...');
                // update gallery omitting ids or adding new ones
                await directusApi('PATCH', `items/products/${db_product.data.data.id_new}`, {
                    gallery,
                    complete_gallery,
                })
                    .then(async (res: any) => {
                        // console.log('new gallery', res.data.data.gallery);
                        dispatch('getOne', db_product.data.data.id_new);
                        // dispatch('getOne', null);
                        alert('Producto Guardado! Obteniendo información...');
                    })
                    .catch(err => {
                        console.log(err);
                    })
                    .finally(async () => {
                        if (productMethod != 'POST') {
                            commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
                        }
                    });
                if (productMethod == 'POST' && !product.is_combo) {
                    await directusApi('GET', `custom/legacy-intelisis/syncSku/${product.id}`)
                        .then(async res => {
                            console.log('Producto sincronizado con intelisis :D');
                            dispatch('getOne', product.id_new);
                        })
                        .catch(err => {
                            console.log({ err });
                        });
                }
            })
            .catch(err => {
                // console.log({ err });
                let errorMessage = err.response.data.errors[0].message;
                if (errorMessage.includes('has to be unique')) {
                    view.$bvToast.toast('El artículo que tratas de agregar ya existe.', {
                        title: `Lo sentimos.`,
                        variant: 'warning',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                }
                commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
            });
    },

    async cacheAll({ _, commit }: any, { search, limit, product }: any) {
        commit('TOGGLE_CACHE_PRODUCTS_LOADING', true);
        let idsNotShow = [];
        if (product) {
            idsNotShow.push(product.id);
        }
        let filter: any = { _and: [] };
        if (search !== null) {
            filter._and.push({
                _or: [{ name: { _contains: search } }, { id: { _contains: search } }],
            });
        }

        let endpoint = `items/products?filter=${JSON.stringify(filter)}&limit=${limit}`;

        // console.log(endpoint);
        await directusApi('GET', endpoint)
            .then(res => {
                let productsCache = res.data.data;
                // console.log({ idsNotShow });
                if (idsNotShow.length > 0) {
                    productsCache = productsCache.filter(function (word: any) {
                        return !idsNotShow.includes(word.id);
                    });
                }
                commit('SET_CACHE_PRODUCTS', productsCache);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_CACHE_PRODUCTS_LOADING', false);
            });
    },
    async getAll({ _, commit }: any, { search, page, sortName, sortValue, brand, category }: any) {
        commit('TOGGLE_ALL_PRODUCTS_LOADING', true);
        /* Old functionality (custom endpoint)
        let params = {};
        if (search) {
            search = search.toUpperCase();
            params = { ...params, search };
        }
        if (page) params = { ...params, page };
        if (sortName) params = { ...params, sortName };
        if (sortValue) params = { ...params, sortValue };
        params = { ...params };
        let query = new URLSearchParams(params);
        let endpoint = `custom/products?${query}`;
        */

        // console.log({ sortName });
        // console.log({ sortValue });

        let limit = 20;
        let params = '';
        if (search) {
            search = search.toUpperCase();
            // params += `&filter[id][_contains]=${search}`;
            params = `&search=${search}`;
        }
        if (brand) {
            params += `&filter[brand]=${brand}`
        }
        if (category) {
            params += `&filter[category]=${category}`
        }

        if (sortName) {
            sortValue == 'ASC' ? params += `&sort=${sortName}` : params += `&sort=-${sortName}`;
        } else {
            params += `&sort=id`;
        }
        //if (sortValue) params += `&filter[id][_contains]=${search}`;

        params += `&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=20&offset=${(page - 1) * limit}`;

        let endpoint = `items/products?${params}&fields=*`;
        // console.log(endpoint);
        // console.log('fetchAll',endpoint);
        // console.log('search => ', search);
        await directusApi('GET', endpoint)
            .then(response => {
                const apiResponse = response.data;
                commit('SET_ALL_PRODUCTS', {
                    items: apiResponse.data,
                    perPage: limit,
                    currentPage: page,
                    totalItems: apiResponse.meta?.filter_count,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
            });
    },

    async getClient({ _, commit }: any, data: any) {
        commit('TOGGLE_ALL_PRODUCTS_LOADING', true);
        if (data.client) {
            data.client = data.client.toUpperCase();
            await directusApi('GET', `items/cte/${data.client}`)
                .then(res => {
                    commit('SET_CLIENT', res.data.data);
                    commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
                })
                .catch(err => {
                    data.vm.$bvToast.toast('No se ha encontrado ninguna coincidencia.', {
                        title: `Lo sentimos.`,
                        variant: 'warning',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 5000,
                    });
                    commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
                });
        } else {
            commit('SET_CLIENT', { cliente: null, listapreciosesp: null });
            commit('TOGGLE_ALL_PRODUCTS_LOADING', false);
        }
    },

    async postFile({ _, commit }: any, data: any) {
        console.log({ info: data.data });
        await asyncForEach(data.data, async (file: any) => {
            console.log({ file });
        });
        console.log('post file in progress...');
        // await directusApi('POST', `files/import`, {
        //     url: data.data,
        //     data: { title: 'baby dev' },
        // })
        //     .then(async (resFile: any) => {
        //         console.log({ resFile });
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     });
    },

    async getDocument({ _, commit }: any, product: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_LOADING', true);
        console.log(product.product.data_sheet.id);
        let answer_description, answer_properties, exist_properties, final_properties = [], flag, name_exist, name_bot, properties_no_generated;
        console.log(product.datasheet_save);
        exist_properties = product.product.properties
        let product_name = product.product.name
        // if (product.datasheet_save) {
        let url_document = {
            url: `https://directus.prodelec.app/assets/${product.product.data_sheet.id}`,
            name: product.product.data_sheet.title,
        };
        await directusApi('POST', `custom/ai-connection/ask-description`, {
            file: url_document,
            product: product_name
        })
            .then((res: any) => {
                // console.log(res);
                if (res.status == 200) {
                    answer_description = res.data.description
                    console.log(answer_description);
                    const cleanedJsonString = res.data.features.replace(/\n/g, '').trim()
                    if (cleanedJsonString == "") {
                        answer_description = answer_description;
                        properties_no_generated = true;
                    }
                    else {
                        properties_no_generated = false;
                        answer_properties = JSON.parse(cleanedJsonString);
                        console.log(exist_properties.length);
                        // comparar los arreglos en caso de que ya existan caracteristicas
                        if (exist_properties.length > 0) {
                            console.log(exist_properties);
                            final_properties = exist_properties
                            for (let i = 0; i < answer_properties.length; i++) {
                                flag = false;
                                name_bot = answer_properties[i].name
                                    .toLowerCase()
                                    .replace(/\s+/g, '')
                                    .replace(/[^a-zA-Z0-9]/g, '')
                                    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                                for (let j = 0; j < exist_properties.length; j++) {
                                    name_exist = exist_properties[j].name
                                        .toLowerCase()
                                        .replace(/\s+/g, '')
                                        .replace(/[^a-zA-Z0-9]/g, '')
                                        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                                    if (name_bot === name_exist) {
                                        flag = true;
                                        break;
                                    }
                                }
                                if (flag == false) {
                                    final_properties.push(answer_properties[i])
                                }
                            }
                        }
                        else {
                            final_properties = answer_properties
                            // console.log(final_properties);
                        }
                    }
                }
                else {
                    answer_description = "No es posible generar la descripcion"
                }
            })
            .catch(err => {
                answer_description = 'Error al crear la descripción debido a que el documento no esta guardado';
                product.vm.$bvToast.toast('No se ha podido realizar la descripcion.', {
                    title: `Error al generar.`,
                    variant: 'warning',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
            });
        commit('TOGGLE_ACTIVE_PRODUCT_LOADING', false);
        console.log(final_properties);
        return { answer_description, final_properties, properties_no_generated };
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};